import { ApiSuccessResponse } from "../../@types";
import { apiSlice } from "../../app/api/apiSlice";
import { Partner, PartnerSearchResponse, PartnerStats } from "./@types";

export const partnerApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPartners: builder.mutation<
      ApiSuccessResponse<PartnerSearchResponse>,
      Record<string, any>
    >({
      query: (data) => ({
        url: "/partner/partners",
        method: "POST",
        body: { ...data },
      }),
    }),
    getPartnerStats: builder.query<ApiSuccessResponse<PartnerStats>, void>({
      query: () => ({
        url: "/partner/partnerstat-for-company",
        method: "GET",
      }),
    }),
    addPartner: builder.mutation<ApiSuccessResponse<any>, Record<string, any>>({
      query: (data) => ({
        url: "/partner/partner",
        method: "POST",
        body: { ...data },
      }),
    }),
    updatePartner: builder.mutation<
      ApiSuccessResponse<any>,
      Record<string, any>
    >({
      query: (data) => ({
        url: `/partner/partners/${data.id}`,
        method: "PUT",
        body: { ...data },
      }),
    }),
    getPartnerById: builder.query<ApiSuccessResponse<Partner>, string>({
      query: (id) => ({
        url: `/partner/partners/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetPartnersMutation,
  useGetPartnerStatsQuery,
  useAddPartnerMutation,
  useUpdatePartnerMutation,
  useGetPartnerByIdQuery,
} = partnerApiSlice;
